module.exports = {"type":"symbol","shape":"circle","name":"singleNodeSymbols","from":{"data":"singleNodes"},"encode":{"update":{"x":{"field":"x"},"y":{"field":"y"},"fill":{"field":"color"},"stroke":{"value":"#4374A0"},"opacity":{"field":"opacity"},"size":{"value":300}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/single-nodes/symbol.json
// module id = hbm4
// module chunks = 0